import React from 'react'

const displayError = (error,navigate,setUser) =>{
    console.log("errrrr");
    console.log(error.response.data)
    if(error.response.data.statusCode === 403){
        setUser(null)
        navigate("/login",{state:{message:"Session Expired ! Please Login"}})
    }else{
        return typeof error?.response.data?.custommessage ==='object'?
        JSON.stringify(error?.response.data?.custommessage):
        error?.response.data?.custommessage
    }
}

export default displayError